import React, { useContext, useEffect, useMemo } from 'react'
import LanguageContext from '../../contexts/languageContext'
import { getLanguageFromUrl } from '../../utils/navigation'
import styles from './styles.module.css'
import useMounted from '../../hooks/useMounted'
import HomePage from '../../components/HomePage'
import Seo from '../../components/SEO'

const MainLayout = ({ data, location, lang }) => {
  const hasMounted = useMounted()
  const { langContext, setLanguage } = useContext(LanguageContext)
  const titleHeader = useMemo(() => (lang === 'en' ? 'Home' : 'Página inicial'), [lang])

  useEffect(() => {
    setLanguage(getLanguageFromUrl(location.pathname))
  }, [setLanguage, location.pathname])

  return (
    <>
      <Seo
        title={`${titleHeader} - Hotmart Developers`}
        distinctLangs={['pt-BR', 'en', 'es']}
        locale={langContext}
        tags={['Hotmart', 'Developers', 'API', 'Documentation']}
        url={location && location.pathname}
      />

      {hasMounted && (
        <div className={styles.authenticationWrapper}>
          <HomePage data={data?.allMarkdownRemark} location={location} />
        </div>
      )}
    </>
  )
}

export default MainLayout
